import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import branding from 'shared/app/model/branding';
import { darken, lighten, styled } from '@mui/material';
import { grey } from '@mui/material/colors';
const frequently_used_grey = '#e0e0e0';
const darken_grey = '#5c5c5c';
const autoscan_color_background = '#05adca';
const zont_color = '#2ababe';
export const styleOverrides = (theme) => {
    const is_autoscan = branding.code === 'autoscan';
    const is_dark = theme.palette.mode === 'dark';
    const multiConditions = (conditions) => {
        const { condition_zont, condition_zont_dark, condition_autoscan, condition_autoscan_dark, } = conditions;
        //Зонтовская тема
        if (!is_autoscan) {
            //Если тёмная
            if (is_dark) {
                //и есть условие по тёмной теме
                return condition_zont_dark != null
                    ? condition_zont_dark
                    : condition_zont != null
                        ? condition_zont
                        : '';
            }
            //Если светлая
            return condition_zont != null ? condition_zont : '';
            //Если автоскан
        }
        else {
            //Если тёмная
            if (is_dark) {
                //и есть условие по тёмной теме
                return condition_autoscan_dark != null
                    ? condition_autoscan_dark
                    : condition_zont_dark != null
                        ? condition_zont_dark
                        : condition_autoscan != null
                            ? condition_autoscan
                            : condition_zont != null
                                ? condition_zont
                                : '';
            }
            //Если светлая
            return condition_autoscan != null
                ? condition_autoscan
                : condition_zont != null
                    ? condition_zont
                    : '';
        }
    };
    return {
        //Перекрасит все надписи
        // '& .MuiTypography-root': {
        //     color: 'red',
        // },
        //Перекрашиваем кнопки
        '& button:not([class^="MuiButtonBase-root"]):not(.ui.button):not([class*="react"])': {
            color: theme.palette.text.primary,
            backgroundColor: multiConditions({
                condition_zont: '#eceaeb',
                condition_zont_dark: theme.palette.background.paper,
            }),
            '&:hover': {
                background: multiConditions({
                    condition_zont: `${darken(theme.palette.background.paper, 0.3)}!important`,
                }),
            },
            '&:active': {
                color: theme.palette.common.white,
                background: zont_color,
            },
        },
        '& .ui-graphs-tab-zn': {
            '& .ui-graph-block': {
                borderLeft: `3px solid ${theme.palette.primary.dark}`,
            },
            '& .ui-graph-block-unit': {
                color: multiConditions({
                    condition_zont: theme.palette.text.secondary,
                    condition_zont_dark: theme.palette.common.white,
                }),
            },
            '& .ui-graph-block-tooltip': {
                background: theme.palette.background.paper,
                color: theme.palette.text.primary,
                borderLeft: `3px solid ${theme.palette.primary.dark}`,
                // '&.right-block': {
                //     borderLeft: 'none',
                //     borderRight: `3px solid ${theme.palette.primary.dark}`,
                // },
                '& .ui-graph-block-hover-legend': {
                    borderBottom: `1px solid ${theme.palette.mode === 'dark' ? '#545454' : '#e7e6e6'}`,
                },
            },
        },
        //Пустой интерфейс
        '& .ui-tabs-stub-container': {
            background: theme.palette.background.default,
        },
        '& .zth-dashboard': {
            background: theme.palette.background.default,
            '& .icon': {
                filter: multiConditions({
                    condition_zont_dark: `invert(1)`,
                }),
            },
        },
        //Полоска сверху интерфейса
        '& .ui-header': {
            background: multiConditions({
                condition_zont: theme.palette.background.default,
                condition_autoscan: autoscan_color_background,
                condition_autoscan_dark: darken(autoscan_color_background, 0.2),
            }),
            color: theme.palette.text.primary,
            borderBottomColor: darken(theme.palette.background.default, 0.2),
            '& .ui-header-help-2': {
                filter: multiConditions({
                    condition_zont_dark: `invert(1)`,
                    condition_autoscan_dark: '',
                }),
            },
            '& .ui-header-user-2': {
                '& .icon': {
                    filter: multiConditions({
                        condition_zont_dark: `invert(1)`,
                    }),
                },
            },
            '& .ui-header-right': {
                '& .ui-header-sims-button': {
                    '& .title': {
                        color: theme.palette.text.primary,
                        '&.warning': {
                            color: theme.palette.mode == 'dark' ? '#ff6d63' : '#c4443b',
                        },
                    },
                },
                '& .ui-header-eye': {
                    filter: multiConditions({
                        condition_zont_dark: 'invert(1)',
                    }),
                },
            },
        },
        //Всплывающее меню по пользователю
        '& .ui-header-popup-item': {
            '&.header': {
                background: theme.palette.background.paper,
                color: theme.palette.text.primary,
                '& .ui-header-eye': {
                    filter: multiConditions({
                        condition_zont_dark: 'invert(1)',
                    }),
                },
            },
            '&:hover': {
                background: theme.palette.background.default,
            },
        },
        //Важные события и новости
        '& .ui-events-notifier-title': {
            color: multiConditions({
                condition_zont: theme.palette.text.primary,
                condition_autoscan: theme.palette.common.white,
            }),
        },
        '& .ui-upgrades-notifier-title': {
            color: multiConditions({
                condition_zont: theme.palette.text.primary,
                condition_autoscan: theme.palette.common.white,
            }),
        },
        '& .ui-events-notifier.ui-events-notifier-highlight': {
            '& .ui-events-notifier-number': {
                background: multiConditions({
                    condition_zont_dark: '#fe6021',
                }),
            },
        },
        '& .ui-events-notifier-number': {
            background: multiConditions({
                condition_zont: '#ccc',
                condition_zont_dark: theme.palette.background.paper,
                condition_autoscan: 'rgba(255, 255, 255, 0.6)',
                condition_autoscan_dark: darken(autoscan_color_background, 0.5),
            }),
            color: multiConditions({
                condition_zont: theme.palette.background.default,
                condition_zont_dark: theme.palette.text.primary,
                condition_autoscan: autoscan_color_background,
                condition_autoscan_dark: theme.palette.text.primary,
            }),
            '&.mobile': {
                background: multiConditions({
                    condition_zont: '#ccc',
                    condition_autoscan: 'rgba(255, 255, 255, 0.6)',
                }),
            },
        },
        //Обновления сверху страницы
        '& .ui-upgrades-notifier-button': {
            '& .ui-upgrades-notifier-icon': {
                background: multiConditions({
                    condition_autoscan_dark: darken(autoscan_color_background, 0.5),
                }),
            },
        },
        '& .ui-upgrades-notifier-button-container': {
            '& button:not([class^="MuiButtonBase-root"]):not(.ui.button):not([class*="react"])': {
                color: theme.palette.text.primary,
                backgroundColor: multiConditions({
                    condition_zont: '#eceaeb',
                    condition_zont_dark: theme.palette.background.paper,
                }),
                '&:active': {
                    color: theme.palette.common.white,
                    background: zont_color,
                },
            },
        },
        //Диалог с событиями
        '& .ui-events-notifier-popup, .news-dialog-body': {
            '& .r-news, .r-events': {
                '& .icon': {
                    color: multiConditions({
                        condition_zont: '#505050',
                        condition_zont_dark: theme.palette.text.primary,
                    }),
                },
                '& .body': {
                    '& .header': {
                        '& .title': {
                            color: multiConditions({
                                condition_zont: '#505050',
                                condition_zont_dark: theme.palette.text.primary,
                            }),
                        },
                    },
                    '& .details': {
                        color: theme.palette.text.secondary,
                    },
                    '& .footer': {
                        '& .date': {
                            color: multiConditions({
                                condition_zont: '#777',
                                condition_zont_dark: theme.palette.text.primary,
                            }),
                        },
                    },
                },
            },
        },
        '& .r-important-event': {
            '& .icon': {
                filter: multiConditions({
                    condition_zont_dark: 'invert(1)',
                }),
            },
        },
        //Список устройств
        '& .ui-leftpanel, .ui-left-menu': {
            background: theme.palette.background.default,
            color: theme.palette.text.primary,
            '& .MuiChip-root': {
                '&:focus': {
                    backgroundColor: 'transparent',
                },
            },
            '& .MuiAccordionDetails': {
                '&-root': {
                    padding: '6px 12px',
                },
            },
            '& .MuiAccordionSummary': {
                '&-root': {
                    minHeight: 50,
                    padding: '0 7px',
                    backgroundColor: multiConditions({
                        condition_zont: '#f0f0f0',
                        condition_zont_dark: '#303030',
                        condition_autoscan: '#f0f0f0',
                        condition_autoscan_dark: '#303030',
                    }),
                },
                '&-content': {
                    margin: '5px 0',
                },
            },
            '& .MuiPaper-elevation1': {
                boxShadow: 'none',
                backgroundColor: multiConditions({
                    condition_zont: '#ebebeb',
                    condition_zont_dark: '#2e2d2d',
                    condition_autoscan: '#ebebeb',
                    condition_autoscan_dark: '#2e2d2d',
                }),
            },
            '& .ui-device-list-device-icon': {
                filter: multiConditions({
                    condition_zont_dark: 'invert(1)',
                    condition_autoscan_dark: 'invert(1)',
                }),
                '& .ui-state-filter-icon': {
                    width: 22,
                    height: 22,
                },
            },
            '& .ui-state-filter-icon': {
                width: 24,
                height: 24,
            },
            '& .ui-device-list-empty': {
                textShadow: multiConditions({
                    condition_zont: '0px 1px 0px rgb(255 255 255)',
                    condition_zont_dark: 'none',
                }),
            },
            //панель сводка
            '& .ui-leftpanel-zth-dashboard-link': {
                background: theme.palette.background.default,
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: multiConditions({
                    condition_zont: frequently_used_grey,
                    condition_zont_dark: darken(theme.palette.background.paper, 0.1),
                }),
                '&.active': {
                    background: multiConditions({
                        condition_zont: frequently_used_grey,
                        condition_zont_dark: darken(theme.palette.background.paper, 0.8),
                    }),
                },
                '&:hover': {
                    background: theme.palette.background.paper,
                },
            },
            '& .ui-leftpanel-header-title': {
                color: theme.palette.text.primary,
            },
            '& .ui-leftpanel-devices-header': {
                color: theme.palette.text.primary,
                borderColor: multiConditions({
                    condition_zont: frequently_used_grey,
                    condition_zont_dark: theme.palette.background.paper,
                }),
                '& .ui-icon-devicelist-add': {
                    filter: multiConditions({
                        condition_zont_dark: 'invert(1)',
                    }),
                },
            },
            '& .ui-leftpanel-search': {
                borderColor: multiConditions({
                    condition_zont: frequently_used_grey,
                    condition_zont_dark: theme.palette.background.paper,
                }),
                '& .active': {
                    '& input': {
                        color: multiConditions({
                            condition_zont_dark: theme.palette.common.black,
                            condition_autoscan_dark: theme.palette.common.black,
                        }),
                    },
                },
                '& input': {
                    borderColor: is_dark
                        ? theme.palette.background.paper
                        : frequently_used_grey,
                    '&:hover': {
                        background: multiConditions({
                            condition_zont: lighten(frequently_used_grey, 0.7),
                            condition_zont_dark: darken(theme.palette.background.default, 0.3),
                        }),
                    },
                    '&:focus': {
                        background: multiConditions({
                            condition_zont: lighten(frequently_used_grey, 0.7),
                            condition_zont_dark: darken(theme.palette.background.default, 0.3),
                        }),
                    },
                },
                '& span': {
                    filter: multiConditions({
                        condition_zont_dark: 'invert(1)',
                    }),
                    '&:hover': {
                        opacity: 1,
                    },
                },
            },
            '& .ui-left-menu-footer': {
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: multiConditions({
                    condition_zont: frequently_used_grey,
                    condition_zont_dark: darken(theme.palette.background.paper, 0.1),
                }),
            },
            '& .ui-left-menu-item-icon, .ui-left-menu-logout, .ui-left-menu-device-delete': {
                filter: multiConditions({
                    condition_zont_dark: 'invert(1)',
                }),
            },
            '& .ui-left-menu-additional-button-with-menu': {
                color: multiConditions({
                    condition_zont: 'rgb(47, 47, 47)',
                    condition_zont_dark: theme.palette.text.primary,
                }),
            },
        },
        '& .ui-leftpanel-devices-list': {
            color: theme.palette.text.primary,
            '& .ui-device-list-device': {
                background: theme.palette.background.default,
                '&.selected': {
                    background: multiConditions({
                        condition_zont: frequently_used_grey,
                        condition_zont_dark: `${theme.palette.background.paper}!important`,
                    }),
                },
                '&:hover': {
                    background: theme.palette.background.paper,
                },
            },
            '& .ui-device-list-device-texts': {
                borderTopColor: multiConditions({
                    condition_zont: theme.palette.common.white,
                    condition_zont_dark: theme.palette.background.paper,
                }),
                borderBottomColor: multiConditions({
                    condition_zont: frequently_used_grey,
                    condition_zont_dark: theme.palette.background.paper,
                }),
            },
            '& .ui-device-list-device-name': {
                color: theme.palette.text.primary,
            },
            '& .ui-device-list-device-icon': {
                filter: multiConditions({
                    condition_zont_dark: 'invert(1)',
                }),
            },
        },
        '& .rowSelected': {
            background: multiConditions({
                condition_zont: 'rgba(47, 47, 47, 0.3)',
                condition_zont_dark: darken(theme.palette.background.paper, 0.8),
                condition_autoscan: 'rgba(47, 47, 47, 0.3)',
                condition_autoscan_dark: darken(theme.palette.background.paper, 0.8),
            }),
            '&.zontRowSelected': {
                background: multiConditions({
                    condition_zont: '#c4c4c4',
                    condition_zont_dark: darken(theme.palette.background.paper, 0.8),
                }),
                '&:hover': {
                    background: multiConditions({
                        condition_zont: darken('#c4c4c4', 0.05),
                        condition_zont_dark: darken(theme.palette.background.paper, 0.6),
                    }),
                },
            },
        },
        '& .rowGroup': {
            background: multiConditions({
                condition_zont: 'rgba(47, 47, 47, 0.1)',
                condition_zont_dark: darken(theme.palette.background.paper, 0.4),
                condition_autoscan: 'rgba(47, 47, 47, 0.1)',
                condition_autoscan_dark: darken(theme.palette.background.paper, 0.4),
            }),
            color: multiConditions({
                condition_zont: 'rgb(71,71,71)',
                condition_zont_dark: 'rgb(230,230,230)',
                condition_autoscan: 'rgb(71,71,71)',
                condition_autoscan_dark: 'rgb(230,230,230)',
            }),
            borderTopColor: multiConditions({
                condition_zont: 'rgba(47, 47, 47, 0.05)!important',
                condition_zont_dark: `${lighten(theme.palette.background.paper, 0.2)}!important`,
                condition_autoscan: 'rgba(47, 47, 47, 0.05)!important',
                condition_autoscan_dark: `${lighten(theme.palette.background.paper, 0.2)}!important`,
            }),
            borderBottomColor: multiConditions({
                condition_autoscan: 'rgba(47, 47, 47, 0.05)!important',
                condition_autoscan_dark: `${lighten(theme.palette.background.paper, 0.2)}!important`,
                condition_zont: 'rgba(47, 47, 47, 0.05)!important',
                condition_zont_dark: `${lighten(theme.palette.background.paper, 0.2)}!important`,
            }),
        },
        '& .rowContents': {
            borderTopColor: multiConditions({
                condition_autoscan: 'rgb(255, 255, 255)',
                condition_autoscan_dark: lighten(theme.palette.background.paper, 0.1),
                condition_zont: 'rgb(255, 255, 255)',
                condition_zont_dark: lighten(theme.palette.background.paper, 0.1),
            }),
            borderBottomColor: multiConditions({
                condition_zont: 'rgb(224, 224, 224)',
                condition_zont_dark: lighten(theme.palette.background.paper, 0.1),
                condition_autoscan: 'rgb(224, 224, 224)',
                condition_autoscan_dark: lighten(theme.palette.background.paper, 0.1),
            }),
            borderBottomWidth: multiConditions({
                condition_zont: '1px',
                condition_zont_dark: '0',
                condition_autoscan: '1px',
                condition_autoscan_dark: '0',
            }),
            borderLeftWidth: multiConditions({
                condition_zont: '1px',
                condition_zont_dark: '0',
                condition_autoscan: '1px',
                condition_autoscan_dark: '0',
            }),
            '& .MuiSvgIcon-root': {
                color: multiConditions({
                    condition_zont: 'rgb(71,71,71)',
                    condition_zont_dark: 'rgb(240,240,240)',
                    condition_autoscan: 'rgb(71,71,71)',
                    condition_autoscan_dark: 'rgb(240,240,240)',
                }),
            },
            '&:hover': {
                background: multiConditions({
                    condition_zont: '#fafafa',
                    condition_zont_dark: darken(theme.palette.background.paper, 0.5),
                    condition_autoscan: '#fafafa',
                    condition_autoscan_dark: darken(theme.palette.background.paper, 0.5),
                }),
            },
            '& .ui-device-list-device-icon': {
                filter: multiConditions({
                    condition_zont_dark: 'invert(1)',
                    condition_autoscan_dark: 'invert(1)',
                }),
            },
        },
        '& .ui-car-image': {
            filter: multiConditions({
                condition_zont_dark: `brightness(0.9)`,
            }),
        },
        '& .ui-card-icon': {
            filter: multiConditions({
                condition_zont_dark: 'invert(1)',
            }),
        },
        '& .car-indicator-value': {
            color: multiConditions({
                condition_zont_dark: theme.palette.text.primary,
            }),
        },
        //Z3kGuardTab
        '& .ui-base-sensor': {
            background: theme.palette.background.paper,
            position: 'relative',
            '& .title': {
                '& .title-name': {
                    color: multiConditions({
                        condition_zont: '#777',
                        condition_zont_dark: theme.palette.text.secondary,
                    }),
                },
                '& .title-icon': {
                    filter: multiConditions({
                        condition_zont_dark: 'invert(1)',
                    }),
                },
            },
            '& .children': {
                display: 'flex',
                columnGap: 8,
                '& .text': {
                    color: theme.palette.text.primary,
                },
                '& .svg-icon': {
                    color: multiConditions({
                        condition_zont: '#474747',
                        condition_zont_dark: theme.palette.text.primary,
                    }),
                },
                '&.active': {
                    '& .svg-icon': {
                        '&.alarm-icon:after': {
                            border: '6px solid #c4443b',
                        },
                    },
                },
            },
            '&.active': {
                background: '#c4443b',
                color: '#f1f1f1',
                '& .title': {
                    '& .title-name': {
                        color: '#f1f1f1',
                    },
                },
                '& .children': {
                    '&.active': {
                        '& .svg-icon': {
                            color: theme.palette.common.white,
                            '&.alarm-icon:after': {
                                border: `6px solid ${theme.palette.common.white}`,
                            },
                            '& .red-alarm-icon': {
                                filter: 'invert(1) brightness(10)',
                            },
                        },
                        '& .text': {
                            color: theme.palette.common.white,
                        },
                    },
                },
            },
            '&.no-connection': {
                borderWidth: 2,
                borderStyle: 'solid',
                borderColor: '#c4443b',
                '& .no-connection-text': {
                    color: '#c4443b',
                },
            },
        },
        '& .ui-control-block': {
            background: multiConditions({
                condition_zont_dark: theme.palette.background.default,
            }),
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: multiConditions({
                condition_zont: '#bebebe',
                condition_zont_dark: theme.palette.text.secondary,
            }),
            '& .ui-icon-control-button-menu-button': {
                filter: multiConditions({
                    condition_zont_dark: 'invert(1)',
                }),
            },
            '& .ui-control-button-background': {
                backgroundColor: multiConditions({
                    condition_zont: '#d0d0d0',
                    condition_zont_dark: theme.palette.background.default,
                }),
                '& .rotor, .stator': {
                    backgroundColor: multiConditions({
                        condition_zont: '#9d9d9d',
                        condition_zont_dark: theme.palette.background.paper,
                    }),
                },
                '& .ui-control-button': {
                    border: multiConditions({
                        condition_zont_dark: `1px solid ${theme.palette.text.secondary}`,
                    }),
                    '& .ui-control-button-icon': {
                        filter: multiConditions({
                            condition_zont_dark: 'invert(1)',
                        }),
                    },
                },
                '&.active': {
                    backgroundColor: zont_color,
                    '& .rotor, .stator': {
                        backgroundColor: '#1c7d7f',
                    },
                    '& .ui-control-button': {
                        '& .ui-control-button-icon': {
                            filter: multiConditions({
                                condition_zont_dark: 'none',
                            }),
                        },
                    },
                    '&.confirmed': {
                        '& .rotor, .stator': {
                            backgroundColor: '#00416b',
                        },
                    },
                },
                '&.confirmed': {
                    backgroundColor: '#0070b7',
                },
            },
        },
        '& .ui-state-tab-show-details-button, .map-tab-loading': {
            textShadow: multiConditions({
                condition_zont: '0px 1px 0px rgb(255 255 255 / 70%)',
                condition_zont_dark: 'none',
            }),
        },
        '& .react-contextmenu.react-contextmenu--visible': {
            background: theme.palette.background.paper,
            '& .react-contextmenu-item': {
                color: theme.palette.text.primary,
            },
        },
        '& .large-tabs-content': {
            background: theme.palette.background.default,
            color: theme.palette.text.primary,
        },
        '& .ui-time-graph-buttons': {
            '& .ui-time-graph-button': {
                color: theme.palette.text.primary,
                '&:hover': {
                    color: is_dark ? '#0092c3' : '#f0662f',
                },
                filter: multiConditions({
                    condition_zont_dark: 'invert(1)',
                }),
            },
        },
        //Строчка с кнопками на графиках
        '& .ui-graphs-toolbar': {
            '& .ui-graphs-control-link': {
                color: theme.palette.text.primary,
                display: 'flex',
                columnGap: 4,
                '&:hover': {
                    color: is_dark ? '#0092c3' : '#f0662f',
                },
                '& .ui-icon-graph-control-add': {
                    filter: multiConditions({
                        condition_zont_dark: 'invert(1)',
                    }),
                },
                '& .ui-icon-graph-print': {
                    filter: multiConditions({
                        condition_zont_dark: 'invert(1)',
                    }),
                },
            },
            '& .ui-icon-graph-wheel-zoom, .ui-icon-graph-wheel-scroll': {
                filter: multiConditions({
                    condition_zont_dark: 'invert(1)',
                }),
            },
        },
        //Строчка с периодом
        '& .ui-period-widget': {
            color: theme.palette.text.primary,
            '& .ui-icon-periodwidget-period': {
                filter: multiConditions({
                    condition_zont_dark: 'invert(1)',
                }),
            },
        },
        //События - фильтр
        '& .ui-events-tab-filter': {
            color: theme.palette.text.primary,
            '& .ui-events-tab-filter-icon': {
                filter: multiConditions({
                    condition_zont_dark: 'invert(1)',
                }),
                '& .ui-icon-eventlist-filter': {
                    filter: multiConditions({
                        condition_zont_dark: 'invert(1)',
                    }),
                },
            },
        },
        //Левая часть диалога
        '& .tabbed-dialog-container > aside': {
            background: theme.palette.background.default,
            color: theme.palette.text.primary,
            borderColor: is_dark
                ? theme.palette.background.paper
                : frequently_used_grey,
            '& .header': {
                '& h2': {
                    color: theme.palette.text.primary,
                },
            },
        },
        '& .tabbed-dialog-container > aside ul li': {
            color: theme.palette.text.primary,
            '&.selected': {
                color: theme.palette.common.white,
            },
        },
        '& .tabbed-dialog-container': {
            background: theme.palette.background.paper,
        },
        // чекбоксы
        '& .ui.toggle.checkbox label': {
            color: theme.palette.text.primary,
        },
        '& .ui.toggle.checkbox input:checked~.box, .ui.toggle.checkbox input:checked~label': {
            color: `${theme.palette.text.primary} !important`,
        },
        //Диалог автоскановский
        '& .ui.form': {
            '& .content, .segment': {
                background: is_dark ? theme.palette.background.paper : '#f5f5f5',
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: is_dark ? darken_grey : 'rgba(34,36,38,.1)',
                boxShadow: is_dark
                    ? '0 1px 3px 0 #5c5c5c,0 0 0 1px #5c5c5c'
                    : '0 1px 3px 0 #d4d4d5,0 0 0 1px #d4d4d5',
            },
            '& .header': {
                color: theme.palette.text.primary,
            },
            '& .field>label': {
                color: theme.palette.text.primary,
            },
            '& textarea': {
                background: theme.palette.background.paper,
                color: theme.palette.text.primary,
            },
            '& .field>.selection.dropdown': {
                background: theme.palette.background.paper,
                color: theme.palette.text.primary,
                '& .text': {
                    color: theme.palette.text.primary,
                },
                '& i': {
                    filter: is_dark ? 'inherit' : '',
                },
            },
            '& .menu': {
                background: theme.palette.background.paper,
                '& .item': {
                    color: theme.palette.text.primary,
                    borderTopWidth: 1,
                    borderTopStyle: 'solid',
                    borderTopColor: is_dark ? darken_grey : '#fafafa',
                },
            },
            //Невалидные поля
            '& .field.error': {
                '& input:not(.MuiInputBase-input)': {
                    backgroundColor: theme.palette.background.paper,
                    color: theme.palette.text.primary,
                },
                '& textarea': {
                    background: theme.palette.background.paper,
                    color: theme.palette.text.primary,
                },
            },
            '& input:not(.MuiInputBase-input)': {
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary,
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: is_dark ? darken_grey : '#b9b5b2',
                '&:focus': {
                    background: theme.palette.background.paper,
                    color: theme.palette.text.primary,
                },
            },
            '& h3': {
                color: theme.palette.text.primary,
            },
            '& .ui.top.attached.header': {
                background: theme.palette.background.paper,
                color: theme.palette.text.primary,
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: is_dark ? darken_grey : '#b9b5b2',
            },
            '& .ui.attached.segment': {
                background: theme.palette.background.paper,
                color: theme.palette.text.primary,
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: is_dark ? darken_grey : '#b9b5b2',
                boxShadow: is_dark
                    ? '0 1px 3px 0 #5c5c5c,0 0 0 1px #5c5c5c'
                    : '0 1px 3px 0 #d4d4d5,0 0 0 1px #d4d4d5',
            },
            '& .ui.basic.toggle.button': {
                color: is_dark
                    ? `${theme.palette.text.primary}!important`
                    : 'rgb(46,46,46)!important',
                boxShadow: is_dark
                    ? '0 0 0 1px #5c5c5c inset,0 0 0 0 #5c5c5c inset'
                    : '0 0 0 1px rgba(34,36,38,.35) inset,0 0 0 0 rgba(34,36,38,.15) inset',
            },
            '& .ui.selection.dropdown': {
                color: is_dark ? theme.palette.text.primary : 'rgba(0,0,0,.87)',
                background: theme.palette.background.paper,
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: is_dark ? darken_grey : '#b9b5b2',
                '& .text': {
                    color: is_dark ? theme.palette.text.primary : 'rgba(0,0,0,.87)',
                },
            },
            '& .ui.table': {
                color: theme.palette.text.primary,
                background: is_dark ? 'transparent' : '#f5f5f5',
                borderColor: is_dark ? darken_grey : '#b9b5b2',
                '& thead th': {
                    color: theme.palette.text.primary,
                    background: is_dark
                        ? darken(theme.palette.background.paper, 0.1)
                        : '#e8e8e8',
                    borderColor: is_dark ? darken_grey : '#b9b5b2',
                },
                '& tbody tr td': {
                    borderColor: is_dark ? darken_grey : '#b9b5b2',
                },
                '& button': {
                    color: is_dark
                        ? `${theme.palette.text.primary}!important`
                        : 'rgba(0,0,0,.6)!important',
                    '&:hover': {
                        background: `${darken(theme.palette.background.paper, 0.3)}!important`,
                    },
                    '&:focus': {
                        background: `${darken(theme.palette.background.paper, 0.3)}!important`,
                    },
                    boxShadow: multiConditions({
                        condition_zont: '0 0 0 1px rgb(34 36 38 / 15%) inset',
                        condition_zont_dark: `0 0 0 1px ${darken_grey} inset`,
                    }),
                },
            },
            '& .ui.checkbox': {
                '& label': {
                    color: theme.palette.text.primary,
                    '&:before': {
                        color: theme.palette.text.primary,
                        background: multiConditions({
                            condition_zont: 'rgba(0,0,0,0.05)',
                            condition_zont_dark: 'rgba(0,0,0,0.25)',
                        }),
                    },
                    '&:after': {
                        color: theme.palette.primary.main,
                    },
                },
            },
            '& .ui.radio.checkbox': {
                '& label': {
                    color: theme.palette.text.primary,
                    '&:before': {
                        color: theme.palette.text.primary,
                    },
                    '&:after': {
                        color: theme.palette.primary.main,
                        backgroundColor: theme.palette.primary.main,
                    },
                },
            },
            '& .accordion.ui.styled': {
                '& .title': {
                    background: theme.palette.background.paper,
                    color: lighten(theme.palette.text.primary, 0.2),
                },
                '& .active.title': {
                    background: theme.palette.background.paper,
                    color: theme.palette.text.primary,
                    borderBottomWidth: '1px',
                    borderBottomStyle: 'solid',
                    borderBottomColor: theme.palette.divider,
                },
                '& .content': {
                    background: `${darken(theme.palette.background.paper, 0.1)}!important`,
                    color: theme.palette.text.primary,
                    '& input': {
                        color: theme.palette.text.primary,
                        backgroundColor: theme.palette.background.paper,
                        borderWidth: 1,
                        borderStyle: 'solid',
                        borderColor: is_dark ? darken_grey : '#b9b5b2',
                        '&:disabled': {
                            color: theme.palette.text.primary,
                            background: darken(theme.palette.background.paper, 0.2),
                        },
                    },
                    '& .selection.dropdown': {
                        background: theme.palette.background.paper,
                        color: theme.palette.text.primary,
                        '& .text': {
                            color: theme.palette.text.primary,
                        },
                    },
                    '& .menu': {
                        background: theme.palette.background.paper,
                        '& .item': {
                            color: theme.palette.text.primary,
                            borderTopWidth: 1,
                            borderTopStyle: 'solid',
                            borderTopColor: is_dark ? darken_grey : '#fafafa',
                        },
                        '& .header': {
                            color: theme.palette.text.primary,
                        },
                    },
                },
            },
        },
        // Таблицы настраиваем
        '& .ui.table': {
            color: theme.palette.text.primary,
            background: 'transparent',
            '& thead th tr td': {
                color: theme.palette.text.primary,
                background: 'transparent',
            },
        },
        '& .ui.selectable.table tbody tr:hover, .ui.table tbody tr td.selectable:hover': {
            color: `${theme.palette.text.primary} !important`,
            background: `${theme.palette.background.default} !important`,
        },
        '& .ui-account-dialog-logins-icon': {
            '& img': {
                filter: multiConditions({
                    condition_zont_dark: 'invert(1)',
                }),
            },
        },
        '& .r-checkbox-icon': {
            backgroundColor: 'transparent',
        },
        '& select': {
            color: theme.palette.text.primary,
            background: theme.palette.background.paper,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: is_dark ? darken_grey : '#b9b5b2',
        },
        //Показываем палитру цветов
        '& .ui-therm-schedule-show-palette': {
            backgroundColor: theme.palette.background.paper,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: multiConditions({
                condition_zont: '#b9b5b2',
                condition_zont_dark: darken_grey,
            }),
        },
        //Затемнение (здесь нужно для веб-версии)
        '& .mui_basedialog_dimmer, .r-dialog-fader': {
            background: multiConditions({
                condition_zont: 'rgba(0,0,0,0.5)',
            }),
        },
        '& .mui_basedialog': {
            background: theme.palette.background.paper,
        },
        //Старые Диалоги
        '& .r-dialog-container, .mui_basedialog': {
            color: theme.palette.text.primary,
            //Затемнение
            '& .mui_basedialog_dimmer, .r-dialog-fader': {
                background: multiConditions({
                    condition_zont: 'rgb(0,0,0,0.5)',
                }),
            },
            // Средняя часть тройного диалога старого
            '& .mui_basedialog_content': {
                background: theme.palette.background.paper,
                '& .ui-opentherm-dialog, .ui-opentherm-dialog-content, .ui-opentherm-dialog-scroller': {
                    background: 'transparent',
                    '& table': {
                        color: theme.palette.text.primary,
                        background: multiConditions({
                            condition_zont: '#f5f5f5',
                            condition_zont_dark: 'transparent',
                        }),
                        borderColor: multiConditions({
                            condition_zont: '#b9b5b2',
                            condition_zont_dark: 'rgba(34,36,38,.15)',
                        }),
                        '& thead th': {
                            color: theme.palette.text.primary,
                            background: multiConditions({
                                condition_zont: '#e8e8e8',
                                condition_zont_dark: darken(theme.palette.background.paper, 0.1),
                            }),
                            borderColor: multiConditions({
                                condition_zont: '#b9b5b2',
                                condition_zont_dark: 'rgba(34,36,38,.15)',
                            }),
                        },
                        '& tbody tr td': {
                            borderColor: multiConditions({
                                condition_zont: '#b9b5b2',
                                condition_zont_dark: 'rgba(34,36,38,.15)',
                            }),
                        },
                        '& button:not([class^="MuiButtonBase-root"]):not(.ui.button):not([class*="react"])': {
                            color: multiConditions({
                                condition_zont: 'rgba(0,0,0,.6)!important',
                                condition_zont_dark: `${theme.palette.text.primary}!important`,
                            }),
                            backgroundColor: multiConditions({
                                condition_zont: '#eceaeb',
                                condition_zont_dark: theme.palette.background.paper,
                            }),
                            '&:hover': {
                                background: multiConditions({
                                    condition_zont: `${darken(theme.palette.background.paper, 0.3)}!important`,
                                }),
                            },
                            '&:active': {
                                color: theme.palette.common.white,
                                background: zont_color,
                            },
                        },
                    },
                },
            },
            //Левая часть тройного диалога старого
            '& .mui_pageddialog_pages': {
                background: multiConditions({
                    condition_zont: theme.palette.background.default,
                }),
                borderRightWidth: '1px',
                borderRightStyle: 'solid',
                borderRightColor: multiConditions({
                    condition_zont: '#dadada',
                    condition_zont_dark: theme.palette.divider,
                }),
            },
            //Правая часть тройного диалога старого
            '& .mui_pageddialog_rightpanel_content': {
                background: multiConditions({
                    condition_zont: theme.palette.background.default,
                }),
                borderLeftWidth: '1px',
                borderLeftStyle: 'solid',
                borderLeftColor: multiConditions({
                    condition_zont: '#dadada',
                    condition_zont_dark: theme.palette.divider,
                }),
            },
            '& .small-settings-dialog-page-list a:not(:last-child)': {
                borderBottomWidth: 1,
                borderBottomStyle: 'solid',
                borderBottomColor: multiConditions({
                    condition_zont: '#dcdcdc',
                    condition_zont_dark: darken_grey,
                }),
            },
            '& .ui-device-dialog-help-container h2': {
                color: zont_color,
            },
            '& h3:not(.MuiTypography-root)': {
                color: theme.palette.text.primary,
            },
            '& input:not(.MuiInputBase-input)': {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.background.paper,
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: multiConditions({
                    condition_zont: '#b9b5b2',
                    condition_zont_dark: darken_grey,
                }),
                '&:disabled': {
                    color: theme.palette.text.primary,
                    backgroundColor: darken(theme.palette.background.paper, 0.2),
                },
            },
            '& .ui-device-dialog-thermostat-ext-mode': {
                background: 'transparent!important',
            },
            '& .mui_checkbox': {
                backgroundColor: 'transparent',
            },
            '& .ui-therm-schedule-palette': {
                backgroundColor: 'transparent',
            },
            '& .ui-schedule-widget-temp-source': {
                backgroundColor: 'transparent',
            },
            '& .mui_combobox_v2': {
                backgroundColor: 'transparent',
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: multiConditions({
                    condition_zont: '#b9b5b2',
                    condition_zont_dark: darken_grey,
                }),
            },
            '& .ui-device-dialog-thermostat-sensor': {
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: multiConditions({
                    condition_zont: '#b9b5b2',
                    condition_zont_dark: darken_grey,
                }),
            },
            '& .ui-device-dialog-pza-plot': {
                '& .flot-text': {
                    color: is_dark ? theme.palette.text.secondary : 'rgb(84,84,84)',
                },
            },
            '& .ui-device-dialog-rf-device': {
                background: 'transparent',
                '& .title': {
                    color: theme.palette.text.primary,
                },
            },
            '& .ui-icon-device-settings-shock-light, .ui-icon-device-settings-shock-strong, .ui-device-dialog-shock-tilt-low, .ui-device-dialog-shock-tilt-high': {
                filter: multiConditions({
                    condition_zont_dark: 'invert(1)',
                }),
            },
            '& .ui-device-dialog-voice-siren .soundpacks': {
                color: theme.palette.text.primary,
            },
            '& select': {
                color: theme.palette.text.primary,
                background: theme.palette.background.paper,
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: multiConditions({
                    condition_zont: '#b9b5b2',
                    condition_zont_dark: darken_grey,
                }),
            },
            '& button:not([class^="MuiButtonBase-root"]):not(.ui.button):not([class*="react"])': {
                color: multiConditions({
                    condition_zont: 'rgba(0,0,0,.6)!important',
                    condition_zont_dark: `${theme.palette.text.primary}!important`,
                }),
                backgroundColor: multiConditions({
                    condition_zont: '#eceaeb',
                    condition_zont_dark: theme.palette.background.paper,
                }),
                '&:hover': {
                    background: multiConditions({
                        condition_zont: `${darken(theme.palette.background.paper, 0.3)}!important`,
                    }),
                },
                '&:active': {
                    color: theme.palette.common.white,
                    background: zont_color,
                },
            },
            '& .r-dialog-frame': {
                background: theme.palette.background.default,
                color: theme.palette.text.secondary,
                '& .r-dialog-header': {
                    background: theme.palette.background.paper,
                    '& .r-dialog-header-content': {
                        color: multiConditions({
                            condition_zont: '#444',
                            condition_zont_dark: theme.palette.text.primary,
                        }),
                    },
                },
            },
            '& .r-dialog-typography h1 &:not(.MuiTypography-root), h2 &:not(.MuiTypography-root), h3 &:not(.MuiTypography-root), h4 &:not(.MuiTypography-root), h5 &:not(.MuiTypography-root), h6 &:not(.MuiTypography-root)': {
                color: theme.palette.text.primary,
            },
            '& .r-dialog-typography.r-message-box-warning h1': {
                color: theme.palette.error.main,
            },
            '& .r-dialog-body': {
                color: theme.palette.text.primary,
                background: theme.palette.background.paper,
                '& .r-news': {
                    '& .icon': {
                        color: multiConditions({
                            condition_zont: '#505050',
                            condition_zont_dark: theme.palette.text.primary,
                        }),
                    },
                    '& .body': {
                        '& .header': {
                            '& .title': {
                                color: multiConditions({
                                    condition_zont: '#505050',
                                    condition_zont_dark: theme.palette.text.primary,
                                }),
                            },
                        },
                        '& .details': {
                            color: theme.palette.text.secondary,
                        },
                        '& .footer': {
                            '& .date': {
                                color: multiConditions({
                                    condition_zont: '#777',
                                    condition_zont_dark: theme.palette.text.primary,
                                }),
                            },
                        },
                    },
                },
                '& .billing-auto-payment': {
                    background: multiConditions({
                        condition_zont: '#eee',
                        condition_zont_dark: theme.palette.background.default,
                    }),
                },
                '& .ui-opentherm-dialog-section': {
                    background: 'transparent',
                    '& table': {
                        color: theme.palette.text.primary,
                        background: multiConditions({
                            condition_zont: '#f5f5f5',
                            condition_zont_dark: 'transparent',
                        }),
                        borderColor: multiConditions({
                            condition_zont: '#b9b5b2',
                            condition_zont_dark: 'rgba(34,36,38,.15)',
                        }),
                        '& thead th': {
                            color: theme.palette.text.primary,
                            background: multiConditions({
                                condition_zont: '#e8e8e8',
                                condition_zont_dark: darken(theme.palette.background.paper, 0.1),
                            }),
                            borderColor: multiConditions({
                                condition_zont: '#b9b5b2',
                                condition_zont_dark: 'rgba(34,36,38,.15)',
                            }),
                        },
                        '& tbody tr td': {
                            borderColor: multiConditions({
                                condition_zont: '#b9b5b2',
                                condition_zont_dark: 'rgba(34,36,38,.15)',
                            }),
                        },
                        '& button:not([class^="MuiButtonBase-root"]):not(.ui.button):not([class*="react"])': {
                            color: multiConditions({
                                condition_zont: 'rgba(0,0,0,.6)!important',
                                condition_zont_dark: `${theme.palette.text.primary}!important`,
                            }),
                            backgroundColor: multiConditions({
                                condition_zont: '#eceaeb',
                                condition_zont_dark: theme.palette.background.paper,
                            }),
                            '&:hover': {
                                background: multiConditions({
                                    condition_zont: `${darken(theme.palette.background.paper, 0.3)}!important`,
                                }),
                            },
                            '&:active': {
                                color: theme.palette.common.white,
                                background: zont_color,
                            },
                        },
                    },
                },
            },
            '& .r-dialog-footer': {
                background: theme.palette.background.paper,
                '& button:not([class^="MuiButtonBase-root"]):not(.ui.button):not([class*="react"])': {
                    color: theme.palette.text.primary,
                    backgroundColor: multiConditions({
                        condition_zont: '#eceaeb',
                        condition_zont_dark: theme.palette.background.paper,
                    }),
                    '&:hover': {
                        background: multiConditions({
                            condition_zont: `${darken(theme.palette.background.paper, 0.3)}!important`,
                        }),
                    },
                    '&:active': {
                        color: theme.palette.common.white,
                        background: zont_color,
                    },
                },
            },
        },
        '& .mui_popup': {
            zIndex: 1500,
            color: theme.palette.text.secondary,
            background: theme.palette.background.paper,
            '& h2': {
                color: theme.palette.text.primary,
            },
            '& .mui_popup_arrow': {
                filter: multiConditions({
                    condition_zont_dark: 'brightness(0.28)',
                }),
            },
        },
        '& .ui-period-widget-calendar': {
            color: theme.palette.text.secondary,
            background: `${theme.palette.background.paper}!important`,
        },
        //Календарь
        '& .mui_calendar': {
            color: theme.palette.text.secondary,
            background: theme.palette.background.paper,
            '& .mui_calendar_year': {
                background: is_dark ? theme.palette.background.paper : '#f7f7f7',
                borderBottomWidth: 1,
                borderBottomStyle: 'solid',
                borderBottomColor: is_dark ? darken_grey : '#f1f1f1',
            },
            '& .mui_calendar_head': {
                borderBottomWidth: 1,
                borderBottomStyle: 'solid',
                borderBottomColor: is_dark ? darken_grey : '#e9e9e9',
            },
            '& .mui_calendar_month': {
                borderBottomWidth: 1,
                borderBottomStyle: 'solid',
                borderBottomColor: is_dark ? darken_grey : '#e9e9e9',
            },
            '& .mui_calendar_tr': {
                borderTopWidth: 1,
                borderTopStyle: 'solid',
                borderTopColor: is_dark ? darken_grey : '#e9e9e9',
            },
            '& .mui_calendar_td': {
                color: is_dark ? theme.palette.text.secondary : '#cccccc',
                borderLeftWidth: 1,
                borderLeftStyle: 'solid',
                borderLeftColor: is_dark ? darken_grey : '#e9e9e9',
            },
            '& .mui_calendar_td_hl': {
                color: theme.palette.text.primary,
                borderLeftWidth: 1,
                borderLeftStyle: 'solid',
                borderLeftColor: is_dark ? darken_grey : '#e9e9e9',
            },
            '& .mui_calendar_controls': {
                background: is_dark ? theme.palette.background.paper : '#f7f7f7',
                borderTopWidth: 1,
                borderTopStyle: 'solid',
                borderTopColor: is_dark ? darken_grey : '#f1f1f1',
                '& input': {
                    color: theme.palette.text.primary,
                    background: 'transparent',
                    borderWidth: 1,
                    borderStyle: 'solid',
                    borderColor: is_dark ? darken_grey : '#b9b5b2',
                },
            },
            '& .mui_calendar_today': {
                color: '#f0662f',
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: '#f0662f',
            },
            '& .mui_calendar_selected': {
                color: theme.palette.common.white,
            },
        },
        '& .ui-map-tab-graph-pane': {
            background: theme.palette.background.default,
        },
        '& .ui-map-tab-graph-splitter': {
            background: theme.palette.background.default,
        },
        '& .ui-map-tab-graph-splitter-title': {
            color: theme.palette.text.primary,
        },
        '& .ui-map-tab-stats': {
            color: theme.palette.text.primary,
        },
        '& .ui-map-tab-trips-splitter': {
            borderColor: theme.palette.background.paper,
        },
        '& .ui-map-search-field': {
            background: theme.palette.background.default,
            color: theme.palette.text.primary,
        },
        //Подсказка геозоны
        '& .leaflet-popup-content-wrapper': {
            background: theme.palette.background.default,
            color: theme.palette.mode == 'dark' ? theme.palette.text.primary : '',
            '& .ui-map-draw-geozone-popup-name, .ui-event-title,.ui-event-map-details,.ui-event-time, .ui-map-search-result-name': {
                color: theme.palette.text.primary,
            },
            '& h2': {
                color: theme.palette.text.secondary,
            },
            '& .ui-map-draw-geozone-error': {
                color: theme.palette.error.main,
            },
            '& img': {
                filter: theme.palette.mode == 'dark'
                    ? 'invert(62%) sepia(2%) saturate(1384%) hue-rotate(153deg) brightness(91%) contrast(72%)'
                    : 'invert(50%) sepia(8%) saturate(236%) hue-rotate(139deg) brightness(96%) contrast(87%)',
            },
        },
        '& .leaflet-popup-tip': {
            background: theme.palette.background.default,
        },
        //Всплывающая подсказка геозоны
        '& .leaflet-tooltip': {
            background: theme.palette.background.default,
            borderColor: multiConditions({
                condition_zont_dark: darken_grey,
            }),
            '& h2': {
                color: theme.palette.text.secondary,
            },
            '& .ui-map-draw-geozone-tooltip-name': {
                color: theme.palette.text.primary,
            },
            '&-left:before': {
                borderLeftColor: multiConditions({
                    condition_zont_dark: darken_grey,
                }),
            },
            '&-right:before': {
                borderRightColor: multiConditions({
                    condition_zont_dark: darken_grey,
                }),
            },
            '&-top:before': {
                borderTopColor: multiConditions({
                    condition_zont_dark: darken_grey,
                }),
            },
            '&-bottom:before': {
                borderBottomColor: multiConditions({
                    condition_zont_dark: darken_grey,
                }),
            },
        },
        '& .ui-trips-content': {
            '& .ui-trips-list-trip': {
                borderColor: theme.palette.background.paper,
                borderBottomColor: is_dark
                    ? theme.palette.background.default
                    : frequently_used_grey,
                '& .ui-trips-list-trip-title': {
                    color: theme.palette.text.primary,
                },
            },
        },
        '& .ui-trips-list-trip:hover': {
            background: theme.palette.background.paper,
        },
        '& .ui-trips-list-trip:focus': {
            background: theme.palette.background.paper,
        },
        '& .ui-map-tab-graph-splitter-icon': {
            filter: multiConditions({
                condition_zont_dark: 'invert(1)',
            }),
        },
        '& .ui-icon-statistics-distance, .ui-icon-statistics-time': {
            filter: multiConditions({
                condition_zont_dark: 'invert(1)',
            }),
        },
        '& .ui-icon-statistics-speed, .ui-icon-statistics-fuel, .ui-icon-statistics-fuel-cost': {
            filter: multiConditions({
                condition_zont_dark: 'invert(1)',
            }),
        },
        '& .wireframe-medium': {
            background: is_dark ? grey['900'] : frequently_used_grey,
        },
        '& .large-tabs-bar-button': {
            textShadow: is_dark ? 'none' : '0 1px #fff',
        },
        '& .large-tabs-bar-button-icon': {
            filter: multiConditions({
                condition_zont_dark: 'invert(1)',
            }),
        },
        '& .large-tabs-selected': {
            background: theme.palette.background.default,
            color: theme.palette.text.secondary,
        },
        '& .ui-event': {
            borderColor: theme.palette.background.paper,
            borderBottomColor: is_dark
                ? theme.palette.background.default
                : frequently_used_grey,
            '& .ui-event-title': {
                color: theme.palette.text.primary,
            },
            '& .ui-event-icon': {
                filter: multiConditions({
                    condition_zont_dark: 'invert(1)',
                }),
            },
        },
        '& .ui-event.important': {
            '& .ui-event-title': {
                color: theme.palette.error.main,
            },
        },
        '& .ui-event.selected': {
            background: theme.palette.background.paper,
        },
        '& .ui-event:hover': {
            background: theme.palette.background.paper,
        },
        '& .ui-event:focus': {
            background: theme.palette.background.paper,
        },
        '& .ui-card': {
            background: theme.palette.background.paper,
            color: multiConditions({
                condition_zont: '#444',
                condition_zont_dark: theme.palette.text.secondary,
            }),
            '&.ui-thermostat-control-tab-offline': {
                background: multiConditions({
                    condition_zont: '#808080',
                    condition_zont_dark: theme.palette.background.paper,
                }),
            },
            '& h1 *:not(.MuiTypography-root)': {
                color: theme.palette.text.primary,
            },
            '& .ui-graph-block-tooltip': {
                background: theme.palette.background.paper,
                color: theme.palette.text.primary,
            },
            '& .ui-graph-block-stats': {
                color: multiConditions({
                    condition_zont: '#777',
                    condition_zont_dark: theme.palette.text.primary,
                }),
            },
            '& .ui-graph-block-buttons': {
                filter: multiConditions({
                    condition_zont_dark: 'invert(1)',
                }),
            },
            '&.climatic-statusbar': {
                '& .ui-rf-tab-signal, .ui-icon-zta-gsm-signal': {
                    filter: multiConditions({
                        condition_zont_dark: 'invert(1)',
                    }),
                },
            },
        },
        '& .ui-falarm-main-view-filetransfers-progress': {
            color: multiConditions({
                condition_zont: '#777',
                condition_zont_dark: theme.palette.text.primary,
            }),
        },
        '& .ui-falarm-main-view.ui-fixed-alarm-tab': {
            background: theme.palette.background.default,
        },
        '& .ui-falarm-main-view-offline': {
            color: is_dark ? theme.palette.text.primary : '#fff',
            background: is_dark ? theme.palette.background.default : '#808080',
            '& h1': {
                color: is_dark ? theme.palette.text.primary : '#fff',
            },
        },
        '& .ui-splitter:hover': {
            background: is_dark ? theme.palette.background.paper : '#ccc',
        },
        '& .ui.bottom.right.popup': {
            background: theme.palette.background.paper,
            color: theme.palette.text.primary,
        },
        '& .ui-thermometers-view-therm-title': {
            color: multiConditions({
                condition_zont: '#777',
                condition_zont_dark: theme.palette.text.secondary,
            }),
        },
        '& .ui-thermometers-view-therm-value': {
            color: theme.palette.text.primary,
        },
        '& .thermostat-target-temp': {
            background: theme.palette.background.paper,
            '& .thermostat-target-temp-title, .thermostat-target-temp-title-value': {
                color: theme.palette.text.secondary,
            },
            '& .thermostat-target-temp-target': {
                color: theme.palette.text.primary,
            },
        },
        '& .thermostat-target-temp-target-boiler': {
            '& span': {
                color: theme.palette.text.primary,
            },
        },
        '& .ui-thermostat-control-mode, .ui-gtw-main-tab-mode': {
            background: theme.palette.background.default,
            color: multiConditions({
                condition_zont_dark: theme.palette.text.secondary,
            }),
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: multiConditions({
                condition_zont: '#fff',
                condition_zont_dark: darken_grey,
            }),
        },
        '& .ui-thermostat-control-mode.selected, .ui-gtw-main-tab-mode.selected': {
            background: zont_color,
            color: multiConditions({
                condition_zont_dark: theme.palette.text.primary,
            }),
        },
        '& .mui_tumbler_handle.ui-draggable.ui-draggable-handle': {
            background: multiConditions({
                condition_zont: '#444444',
                condition_zont_dark: '#ffffff',
            }),
        },
        '& .topup-form-control': {
            '& input': {
                color: theme.palette.text.primary,
                background: theme.palette.background.paper,
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: multiConditions({
                    condition_zont: '#b9b5b2',
                    condition_zont_dark: darken_grey,
                }),
                '&:disabled': {
                    color: theme.palette.text.primary,
                    background: darken(theme.palette.background.paper, 0.2),
                },
            },
        },
        '& .ui.fluid.vertical.tabular.menu': {
            background: multiConditions({
                condition_zont: theme.palette.background.default,
                condition_zont_dark: theme.palette.background.paper,
            }),
            borderRight: '1px solid transparent',
            '& .item': {
                color: theme.palette.text.primary,
            },
        },
        '& .ui.segment': {
            color: theme.palette.text.secondary,
            background: theme.palette.background.paper,
            '& .ui.basic.button:hover': {
                background: `${darken(theme.palette.background.paper, 0.3)}!important`,
            },
        },
        '& .MuiListItem-container': {
            '& li': {
                listStyleType: 'none',
            },
        },
        '& .corner-notice-body': {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            '& input': {
                backgroundColor: theme.palette.mode == 'dark'
                    ? darken(theme.palette.background.paper, 0.3)
                    : undefined,
            },
        },
    };
};
const size100percents = { position: 'relative', width: '100%', height: '100%' };
const styleOverridesProps = ({ theme }) => styleOverrides(theme);
//@ts-ignore
const Root = styled('div')(styleOverridesProps);
export function StylesOverrides(props) {
    // console.trace('its me!!!!!!!!');
    return (_jsx(Root, { className: "theme-general-div", style: size100percents, children: props.children }));
}
